// Datas de calendário locais: evita deslocações por UTC/DST.
export function dataLocal(valor) {
    if (!valor) return null;
    if (valor instanceof Date) return new Date(valor.getFullYear(), valor.getMonth(), valor.getDate());
    const [ano, mes, dia] = String(valor).split('T')[0].split('-').map(Number);
    const data = new Date(ano, mes - 1, dia);
    return Number.isNaN(data.getTime()) ? null : data;
}
export function indicesObrasEmCurso(obras, agora = new Date()) {
    const hoje = dataLocal(agora);
    return obras.reduce((indices, obra, index) => {
        const inicio = dataLocal(obra.data_inicio), fim = dataLocal(obra.data_fim);
        if ((obra.tipo_obra || 'obra') === 'obra'
            && !['concluida', 'recebida', 'suspensa'].includes(obra.status)
            && inicio && fim && inicio <= hoje && fim >= hoje) indices.push(index);
        return indices;
    }, []);
}
export function gerarTimeline(obras, largura = 1440, agora = new Date()) {
    const hoje = dataLocal(agora);
    const margem = Math.max(35, Math.ceil(largura / 80) + 2);
    const antes = new Date(hoje), depois = new Date(hoje);
    antes.setDate(antes.getDate() - margem);
    depois.setDate(depois.getDate() + margem);
    let inicio = antes, fim = depois;
    obras.forEach(obra => {
        const a = dataLocal(obra.data_inicio), b = dataLocal(obra.data_fim);
        if (a && a < inicio) inicio = a;
        if (b && b > fim) fim = b;
    });
    // Limitar o DOM a um ano sem deixar hoje fora da janela por causa de obras antigas.
    const limitePassado = new Date(hoje);
    limitePassado.setDate(limitePassado.getDate() - 183);
    if (inicio < limitePassado) inicio = limitePassado;
    inicio.setDate(1);
    fim = new Date(fim.getFullYear(), fim.getMonth() + 1, 0);
    const limiteFim = new Date(inicio);
    limiteFim.setDate(limiteFim.getDate() + 365);
    if (fim > limiteFim) fim = limiteFim;
    const dias = [];
    for (const d = new Date(inicio); d <= fim; d.setDate(d.getDate() + 1)) dias.push(new Date(d));
    return dias;
}

// Pesquisa local sobre os mesmos campos apresentados nas linhas do calendário.
export function filtrarObrasPorPesquisa(obras, pesquisa) {
    const normalizar = valor => String(valor ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-PT');
    const termos = normalizar(pesquisa).trim().split(/\s+/).filter(Boolean);
    return obras.filter(obra => {
        const texto = normalizar(`${obra.posicao ?? ''} ${obra.descricao ?? ''}`);
        return termos.every(termo => texto.includes(termo));
    });
}

export function calcularFocoObra(obra, timeline, { largura, altura, topoLinha, alturaLinha }) {
    const inicio = dataLocal(obra.data_inicio);
    if (!inicio) return null;
    const indice = timeline.findIndex(dia => dia.getTime() === inicio.getTime());
    if (indice < 0) return null;
    return {
        left: Math.max(0, indice * 40 + 20 - largura / 2),
        top: Math.max(0, topoLinha + alturaLinha / 2 - altura / 2),
    };
}
